export default __webpack_public_path__ + "static/frederiksplein thumbnail-521125d007e0288e5d0f2990c71f62fc.webp";